import React from 'react'

import MetabaseEmbed from '@aletheia/common/components/MetabaseEmbed'

export const StatisticsUsage: React.FC = () => {
  return (
    <>
      <MetabaseEmbed
        embedType="chart"
        title="Annual active donors"
        src="https://dashboard.effectivealtruism.org/public/question/6bf5d144-c9b4-408b-b912-d59d11be7394"
      />
      <MetabaseEmbed
        embedType="chart"
        title="Monthly active donors"
        src="https://dashboard.effectivealtruism.org/public/question/3b614bc7-8a3c-482c-bbcb-a1dbd09af1d2"
      />
    </>
  )
}

export default StatisticsUsage
